import AddIcon from '@mui/icons-material/Add'
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import {
  Avatar,
  Box,
  Breadcrumbs,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { green } from '@mui/material/colors'
import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import ecuData from '../ecuData.json'
import { useDashboardContext } from '../sideDrawer'

export interface User {
  id: number
  username: string
  firstName: string
  lastName: string
  email: string
  age: number
  logo: File | null
}

export const Ecu: React.FC = () => {
  const { updateContext } = useDashboardContext()

  useEffect(() => {
    let oems = []
    updateContext({ pageTitle: 'OEM' })
    const getoems = async () => {
      const data = await fetch('http://localhost:3001/oems', {
        method: 'GET',
      })
      const jsonData = await data.json()
      oems = jsonData
      console.log(oems)
    }

    getoems()
  }, [updateContext])

  const breadcrumbs = [
    <Typography key='1' color='inherit'>
      Enterprise Architecture
    </Typography>,
    <Typography key='2' color='text.primary'>
      ECU
    </Typography>,
  ]

  return (
    <Box>
      <Breadcrumbs separator={<NavigateNextIcon fontSize='small' />} aria-label='breadcrumb'>
        {breadcrumbs}
      </Breadcrumbs>
      <Avatar
        component={Link}
        to='addecu'
        sx={{ bgcolor: green[500], float: 'right', marginRight: 5, marginBottom: 5, marginTop: 5 }}
      >
        <AddIcon />
      </Avatar>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Model Year</TableCell>
              <TableCell>Tx-Header</TableCell>
              <TableCell>Fx-Header</TableCell>
              <TableCell>Created-on</TableCell>
              <TableCell>Is Active</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {ecuData.ecus.map((ecu) => (
              <TableRow key={ecu.id}>
                <TableCell>{ecu.id}</TableCell>
                <TableCell>{ecu.name}</TableCell>
                <TableCell>{ecu.model}</TableCell>
                <TableCell>{ecu.txHeader}</TableCell>
                <TableCell>{ecu.fxHeader}</TableCell>
                <TableCell>{ecu.created}</TableCell>
                <TableCell>
                  <Button component={Link} to='Updateecu'>
                    <EditIcon />
                  </Button>

                  <Button component={Link} to='addoem'>
                    <DeleteIcon />
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}
